// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles one full-tree left navigation item.
 * Keeps parent open state subtle while reserving the strong blue treatment for the active child.
 */
.left-nav-tree-item {
  border-radius: 0.5rem;
}

.left-nav-tree-item__parent-row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.625rem;
  border-radius: 0.5rem;
  color: #1f2937;
  transition: background-color 120ms ease, color 120ms ease;
  cursor: pointer;
}

.left-nav-tree-item__parent-row:hover,
.left-nav-tree-item__parent-row:focus-visible {
  background: #2f7198;
  color: #ffffff;
  outline: none;
}

.left-nav-tree-item__parent-row--expanded {
  background: #f7faff;
  color: #334155;
}

.left-nav-tree-item__parent-row--active {
  background: #004d80;
  color: #ffffff;
  font-weight: 600;
}

.left-nav-tree-item__parent-row--active:hover,
.left-nav-tree-item__parent-row--active:focus-visible {
  background: #004d80;
  color: #ffffff;
}

.left-nav-tree-item--has-active-child .left-nav-tree-item__parent-row {
  color: #334155;
}

.left-nav-tree-item--has-active-child .left-nav-tree-item__parent-row--expanded {
  background: #f4f8fe;
}

.left-nav-tree-item--has-active-child .left-nav-tree-item__label {
  font-weight: 600;
}

.left-nav-tree-item__parent-row:hover .left-nav-tree-item__triangle,
.left-nav-tree-item__parent-row:focus-visible .left-nav-tree-item__triangle {
  border-top-color: #ffffff;
}

.left-nav-tree-item__icon {
  width: var(--left-nav-tree-icon-size, 1.35rem);
  height: var(--left-nav-tree-icon-size, 1.35rem);
  object-fit: contain;
  display: block;
  flex: 0 0 auto;
}

.left-nav-tree-item__label {
  flex: 1 1 auto;
  min-width: 0;
}

.left-nav-tree-item__toggle {
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  cursor: pointer;
  color: inherit;
}

.left-nav-tree-item__triangle {
  width: 0;
  height: 0;
  border-left: 0.28rem solid transparent;
  border-right: 0.28rem solid transparent;
  border-top: 0.38rem solid currentColor;
  transition: transform 140ms ease;
  transform: rotate(-90deg);
}

.left-nav-tree-item__toggle--expanded .left-nav-tree-item__triangle {
  transform: rotate(0deg);
}

.left-nav-tree-item__children {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  margin-left: 1.75rem;
  transition: max-height 170ms ease, opacity 170ms ease;
}

.left-nav-tree-item__children--expanded {
  max-height: 16rem;
  opacity: 1;
}

.left-nav-tree-item__child {
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  border-radius: 0.375rem;
  padding: 0.375rem 0.5rem;
  color: #334155;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.left-nav-tree-item__child:hover,
.left-nav-tree-item__child:focus-visible {
  background: #2f7198;
  color: #ffffff;
  outline: none;
}

.left-nav-tree-item__child--active {
  background: #004d80;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 8px 16px rgba(47, 111, 237, 0.18);
}

.left-nav-tree-item__child--active:hover,
.left-nav-tree-item__child--active:focus-visible {
  background: #004d80;
  color: #ffffff;
}

@media (max-height: 760px) {
  .left-nav-tree-item__parent-row {
    padding: 0.4rem 0.55rem;
    gap: 0.4rem;
  }
  .left-nav-tree-item__icon {
    width: clamp(1.15rem, 1.25vw, 1.35rem);
    height: clamp(1.15rem, 1.25vw, 1.35rem);
  }
  .left-nav-tree-item__children {
    margin-left: 1.55rem;
  }
  .left-nav-tree-item__child {
    padding: 0.3rem 0.45rem;
  }
}
@media (max-height: 660px) {
  .left-nav-tree-item__parent-row {
    padding: 0.32rem 0.5rem;
    gap: 0.35rem;
  }
  .left-nav-tree-item__label {
    font-size: 0.82rem;
  }
  .left-nav-tree-item__toggle {
    width: 1.1rem;
    height: 1.1rem;
  }
  .left-nav-tree-item__triangle {
    border-left-width: 0.24rem;
    border-right-width: 0.24rem;
    border-top-width: 0.32rem;
  }
  .left-nav-tree-item__children {
    margin-left: 1.35rem;
  }
  .left-nav-tree-item__child {
    padding: 0.25rem 0.4rem;
    font-size: 0.82rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/components/left-nav-tree-item/left-nav-tree-item.component.scss"],"names":[],"mappings":"AAAA;;;EAAA;AAIA;EACI,qBAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,qBAAA;EACA,cAAA;EACA,yDAAA;EACA,eAAA;AACJ;;AAEA;;EAEI,mBAAA;EACA,cAAA;EACA,aAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;;EAEI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;;EAEI,yBAAA;AACJ;;AAEA;EACI,8CAAA;EACA,+CAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;EACA,YAAA;AACJ;;AAEA;EACI,SAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,QAAA;EACA,SAAA;EACA,sCAAA;EACA,uCAAA;EACA,sCAAA;EACA,gCAAA;EACA,yBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,qDAAA;AACJ;;AAEA;EACI,iBAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;AACJ;;AAEA;;EAEI,mBAAA;EACA,cAAA;EACA,aAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,+CAAA;AACJ;;AAEA;;EAEI,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI;IACI,uBAAA;IACA,WAAA;EACN;EAEE;IACI,sCAAA;IACA,uCAAA;EAAN;EAGE;IACI,oBAAA;EADN;EAIE;IACI,uBAAA;EAFN;AACF;AAKA;EACI;IACI,uBAAA;IACA,YAAA;EAHN;EAME;IACI,kBAAA;EAJN;EAOE;IACI,aAAA;IACA,cAAA;EALN;EAQE;IACI,0BAAA;IACA,2BAAA;IACA,yBAAA;EANN;EASE;IACI,oBAAA;EAPN;EAUE;IACI,uBAAA;IACA,kBAAA;EARN;AACF","sourcesContent":["/**\n * Styles one full-tree left navigation item.\n * Keeps parent open state subtle while reserving the strong blue treatment for the active child.\n */\n.left-nav-tree-item {\n    border-radius: 0.5rem;\n}\n\n.left-nav-tree-item__parent-row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 0.625rem;\n    border-radius: 0.5rem;\n    color: #1f2937;\n    transition: background-color 120ms ease, color 120ms ease;\n    cursor: pointer;\n}\n\n.left-nav-tree-item__parent-row:hover,\n.left-nav-tree-item__parent-row:focus-visible {\n    background: #2f7198;\n    color: #ffffff;\n    outline: none;\n}\n\n.left-nav-tree-item__parent-row--expanded {\n    background: #f7faff;\n    color: #334155;\n}\n\n.left-nav-tree-item__parent-row--active {\n    background: #004d80;\n    color: #ffffff;\n    font-weight: 600;\n}\n\n.left-nav-tree-item__parent-row--active:hover,\n.left-nav-tree-item__parent-row--active:focus-visible {\n    background: #004d80;\n    color: #ffffff;\n}\n\n.left-nav-tree-item--has-active-child .left-nav-tree-item__parent-row {\n    color: #334155;\n}\n\n.left-nav-tree-item--has-active-child .left-nav-tree-item__parent-row--expanded {\n    background: #f4f8fe;\n}\n\n.left-nav-tree-item--has-active-child .left-nav-tree-item__label {\n    font-weight: 600;\n}\n\n.left-nav-tree-item__parent-row:hover .left-nav-tree-item__triangle,\n.left-nav-tree-item__parent-row:focus-visible .left-nav-tree-item__triangle {\n    border-top-color: #ffffff;\n}\n\n.left-nav-tree-item__icon {\n    width: var(--left-nav-tree-icon-size, 1.35rem);\n    height: var(--left-nav-tree-icon-size, 1.35rem);\n    object-fit: contain;\n    display: block;\n    flex: 0 0 auto;\n}\n\n.left-nav-tree-item__label {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.left-nav-tree-item__toggle {\n    border: 0;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.25rem;\n    height: 1.25rem;\n    margin-left: auto;\n    cursor: pointer;\n    color: inherit;\n}\n\n.left-nav-tree-item__triangle {\n    width: 0;\n    height: 0;\n    border-left: 0.28rem solid transparent;\n    border-right: 0.28rem solid transparent;\n    border-top: 0.38rem solid currentColor;\n    transition: transform 140ms ease;\n    transform: rotate(-90deg);\n}\n\n.left-nav-tree-item__toggle--expanded .left-nav-tree-item__triangle {\n    transform: rotate(0deg);\n}\n\n.left-nav-tree-item__children {\n    max-height: 0;\n    overflow: hidden;\n    opacity: 0;\n    margin-left: 1.75rem;\n    transition: max-height 170ms ease, opacity 170ms ease;\n}\n\n.left-nav-tree-item__children--expanded {\n    max-height: 16rem;\n    opacity: 1;\n}\n\n.left-nav-tree-item__child {\n    width: 100%;\n    border: 0;\n    background: transparent;\n    text-align: left;\n    border-radius: 0.375rem;\n    padding: 0.375rem 0.5rem;\n    color: #334155;\n    cursor: pointer;\n    transition: background-color 120ms ease, color 120ms ease;\n}\n\n.left-nav-tree-item__child:hover,\n.left-nav-tree-item__child:focus-visible {\n    background: #2f7198;\n    color: #ffffff;\n    outline: none;\n}\n\n.left-nav-tree-item__child--active {\n    background: #004d80;\n    color: #ffffff;\n    font-weight: 600;\n    box-shadow: 0 8px 16px rgba(47, 111, 237, 0.18);\n}\n\n.left-nav-tree-item__child--active:hover,\n.left-nav-tree-item__child--active:focus-visible {\n    background: #004d80;\n    color: #ffffff;\n}\n\n@media (max-height: 760px) {\n    .left-nav-tree-item__parent-row {\n        padding: 0.4rem 0.55rem;\n        gap: 0.4rem;\n    }\n\n    .left-nav-tree-item__icon {\n        width: clamp(1.15rem, 1.25vw, 1.35rem);\n        height: clamp(1.15rem, 1.25vw, 1.35rem);\n    }\n\n    .left-nav-tree-item__children {\n        margin-left: 1.55rem;\n    }\n\n    .left-nav-tree-item__child {\n        padding: 0.3rem 0.45rem;\n    }\n}\n\n@media (max-height: 660px) {\n    .left-nav-tree-item__parent-row {\n        padding: 0.32rem 0.5rem;\n        gap: 0.35rem;\n    }\n\n    .left-nav-tree-item__label {\n        font-size: 0.82rem;\n    }\n\n    .left-nav-tree-item__toggle {\n        width: 1.1rem;\n        height: 1.1rem;\n    }\n\n    .left-nav-tree-item__triangle {\n        border-left-width: 0.24rem;\n        border-right-width: 0.24rem;\n        border-top-width: 0.32rem;\n    }\n\n    .left-nav-tree-item__children {\n        margin-left: 1.35rem;\n    }\n\n    .left-nav-tree-item__child {\n        padding: 0.25rem 0.4rem;\n        font-size: 0.82rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
